<!-- 排出事業者 担当者 -->
<template>
  <div>
    <v-card flat>
      <v-toolbar flat>
        <v-spacer />
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          担当者の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-sheet outlined rounded>
          <v-data-table
            :headers="tableHeaders"
            :items="emissionUsers"
            :items-per-page="-1"
            dense
            disable-sort
            hide-default-footer
          >
            <template v-slot:[`item.person_type`]="{ item }">
              {{ item.person_type | emission_user_person_type_label }}
            </template>
            <template v-slot:[`item.editable`]="{ item }">
              <v-btn
                v-if="$vuetify.breakpoint.mdAndUp"
                icon
                color="info darken-2"
                @click="editButtonClickEvent(item)"
              >
                <v-icon>mdi-file-edit-outline</v-icon>
              </v-btn>
              <v-btn
                v-else
                color="info"
                small
                @click="editButtonClickEvent(item)"
              >
                編集
              </v-btn>
              &nbsp;
              <v-btn
                v-if="$vuetify.breakpoint.mdAndUp"
                color="error"
                icon
                small
                @click="deleteButtonClickEvent(item)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
              <v-btn
                v-else
                color="error"
                small
                @click="deleteButtonClickEvent(item)"
              >
                削除
              </v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
        <v-spacer />
      </v-card-actions>
    </v-card>

    <user-dialog
      :enable-dialog="enableUserDialog"
      :emission-id="emissionId"
      :target-id="targetUserId"
      @closeEvent="closeUserDialog"
      @registerEvent="userDialogCallback"
    />
    <confirm ref="confirm" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UserDialog from '../dialogs/_UserDialog'
import Confirm from '../../../../../components/Confirm'

export default {
  name: 'EmissionPersonForm',
  components: { UserDialog, Confirm },
  mixins: [],
  props: {},
  data () {
    return {
      page: 1,
      totalVisible: 7,
      pagination: {
        total_pages: 0,
        total_count: 0
      },
      enableUserDialog: false,
      emissionId: null,
      targetUserId: null,
      tableHeaders: [
        { value: 'code', text: '担当者コード' },
        { value: 'name', text: '担当者名' },
        { value: 'person_type', text: '担当者種別' },
        { value: 'emission_location_name', text: '担当者利用事業場' },
        { value: 'editable', text: '', align: 'end' },
      ],
      emissionUsers: [],
    }
  },
  computed: {
  },
  created () {
    this.emissionId = Number(this.$route.params.id)
    this.searchEmissionUsers()
  },
  methods: {
    ...mapActions('DriverMasterEmissionUser', {
      fetchEmissionUsers: 'index',
      deleteEmissionUser: 'destroy',
    }),
    addButtonClickEvent () {
      this.targetUserId = null
      this.enableUserDialog = true
    },
    editButtonClickEvent (item) {
      this.targetUserId = item.id
      this.enableUserDialog = true
    },
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteEmissionUser({ emission_id: this.emissionId, id: item.id }).then(() => {
            this.page = 1
            this.searchEmissionUsers()
          })
        }
      })
    },
    closeUserDialog () {
      this.enableUserDialog = false
    },
    userDialogCallback () {
      this.searchEmissionUsers()
      this.closeUserDialog()
    },
    changePage () {
      this.searchEmissionUsers()
    },
    searchEmissionUsers () {
      this.fetchEmissionUsers({ emission_id: this.emissionId, page: this.page }).then((content) => {
        this.emissionUsers = content.users
        this.pagination = content.pagination
      })
    }
  },
}
</script>

<style lang="scss">
.wrap_text   {
  display: inline-block;
  overflow-wrap: break-word;
}
.v-input--radio-group__input legend{
  width: 100%
}
</style>
